import { createFileRoute, notFound } from "@tanstack/react-router";
import { HijriDatePage } from "@/components/pages/HijriDatePage";
import { HIJRI_MONTHS, daysInHijriMonth, hijriToGregorian } from "@/lib/calendar/hijri";
import { MONTH_NAMES_ID } from "@/lib/calendar/dates";

export const Route = createFileRoute("/kalender-hijriah/$hyear/$hmonth/$hday")({
  beforeLoad: ({ params }) => {
    if (
      params.hyear.startsWith("$") ||
      params.hmonth.startsWith("$") ||
      params.hday.startsWith("$")
    ) {
      throw notFound();
    }
  },
  loader: ({ params }) => {
    const hYear = parseInt(params.hyear, 10);
    const hMonth = parseInt(params.hmonth, 10);
    const hDay = parseInt(params.hday, 10);
    if (!Number.isFinite(hYear) || hYear < 1300 || hYear > 1600) throw notFound();
    if (!Number.isFinite(hMonth) || hMonth < 1 || hMonth > 12) throw notFound();
    if (!Number.isFinite(hDay) || hDay < 1 || hDay > daysInHijriMonth(hYear, hMonth)) throw notFound();
    return { hYear, hMonth, hDay };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { hYear, hMonth, hDay } = loaderData;
    const monthName = HIJRI_MONTHS[hMonth - 1];
    const g = hijriToGregorian(hYear, hMonth, hDay);
    const title = `${hDay} ${monthName} ${hYear} H - ${g.d} ${MONTH_NAMES_ID[g.m - 1]} ${g.y}`;
    const desc = `Detail tanggal Hijriah ${hDay} ${monthName} ${hYear} H bertepatan dengan ${g.d} ${MONTH_NAMES_ID[g.m - 1]} ${g.y}, lengkap weton, hari penting Islam, dan libur nasional.`;
    const idUrl = `https://hari.co.id/kalender-hijriah/${hYear}/${hMonth}/${hDay}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: idUrl },
        { property: "og:locale", content: "id_ID" },
      ],
      links: [
        { rel: "canonical", href: idUrl },
      ],
    };
  },
  component: () => {
    const { hYear, hMonth, hDay } = Route.useLoaderData();
    return <HijriDatePage hYear={hYear} hMonth={hMonth} hDay={hDay} />;
  },
  notFoundComponent: () => <div className="p-8 text-center">Tanggal Hijriah tidak valid.</div>,
  errorComponent: ({ error }) => <div className="p-8 text-center">Error: {error.message}</div>,
});